import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { Link } from 'gatsby';
import { DrawerContext } from '../../contexts/DrawerContext';
import RegularMenuWrapper from './regular-menu.style';

const RegularMenu = ({ className, menuItems, drawerClose, ...props }) => {
  const { dispatch } = useContext(DrawerContext);

  // Add all classs to an array
  const addAllClasses = ['regular__menu'];

  // className prop checking
  if (className) {
    addAllClasses.push(className);
  }

  // Close drawer when click on menu item
  const toggleDrawer = () => {
    dispatch({
      type: 'TOGGLE',
    });
  };

  return (
    <RegularMenuWrapper className={addAllClasses.join(' ')} {...props}>
      {menuItems.map((menu, index) => (
        <li key={`menu-item-${index}`}>
          {menu.staticLink ? (
            <a href={menu.path}>{menu.label}</a>
          ) : (
            <>
              {drawerClose ? (
                <Link to={menu.path} onClick={toggleDrawer}>
                  {menu.label}
                </Link>
              ) : (
                <Link to={menu.path}>
                  {menu.label}
                </Link>
              )}
            </>
          )}
        </li>
      ))}
    </RegularMenuWrapper>
  );
};

RegularMenu.propTypes = {
  /** className of the RegularMenu. */
  className: PropTypes.string,

  /** menuItems is an array of object prop which contain your menu
   * data.
   */
  menuItems: PropTypes.array.isRequired,

  /** Style attribute to be passed to the generated <ul/> element [optional]. */
  style: PropTypes.object,
};

RegularMenu.defaultProps = {
  componentTag: 'ul',
};

export default RegularMenu; 